import React from 'react';
import styles from './styles.scss';

interface SupportersHeaderProps {
    supporterCount: number;
}
const SupportersHeader = function SupportersHeader({ supporterCount }: SupportersHeaderProps) {
    return (
        <div className="column">
            <div className={styles['supporters-header']}>
                {`Supporters (${supporterCount})`}
            </div>
        </div>
    );
};

export default SupportersHeader;